import { Listbox } from '@headlessui/react';
import clsx from 'clsx';
import { observer } from 'mobx-react';
import ChevronDown from '../../../../../../Cutesies/ChevronDown';
import Dropdown from './Dropdown';
import { emptyFragment } from '../../../../../../../EmptyFragment';
import { useFilterStoreContext } from '../ModalBody/FilterStores';

function SortTemplate() {
  return (
    <div className="z-10 flex md:flex-row">
      {useFilterStoreContext()
        .map(({ sortStore }) => (
          <Listbox value={sortStore.state.sortOption} onChange={sortStore.updateSelectedValue}>
            {({ open }) => (
              <>
                <div className="relative mt-2">
                  <Listbox.Button
                    className={clsx(
                      'relative cursor-default rounded-md bg-white',
                      'px-3 py-2 text-left text-sm font-medium text-gray-900 shadow-sm ring-1',
                      'w-40 ring-inset ring-gray-300 focus:outline-none sm:leading-6',
                    )}
                  >
                    <span>{sortStore.state.sortOption.label}</span>
                    <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                      <div className="mr-1 h-5 w-5 text-gray-400" aria-hidden="true">
                        <ChevronDown />
                      </div>
                    </span>
                  </Listbox.Button>
                  <Dropdown open={open} />
                </div>
              </>
            )}
          </Listbox>
        ))
        .getOrElse(emptyFragment)}
    </div>
  );
}

export default observer(SortTemplate);
